import React, { ReactElement, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Avatar } from '../Avatar';
import { Button } from '../Button';

type Props = {
  iconName?: IconProp;
  iconClasses?: string;
  logo?: string;
  logoAlt?: string,
  pictureUrl?: string;
  title?: string;
  description: string;
  moreDescription?: string;
  classes?: string;
  hasButton?: boolean;
  buttonComponent?: ReactElement<typeof Button>;
};

const WidgetCard = (props: Props): JSX.Element => {
  const { iconName, iconClasses, logo, logoAlt, pictureUrl, title, description, moreDescription, classes, hasButton = false, buttonComponent } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleIsExpanded = (): void => {
    setIsExpanded(!isExpanded);
  }

  return (
    <div className={`px-4 place-content-center rounded-2xl border-2 group w-full h-full ${classes ?? ''}`}>
      <div className='block mb-3 mt-4'>
        {logo && (
          <img
            className='block mb-2 max-w-[142px]'
            src={logo}
            alt={logoAlt}
          />
        )}
        {iconName && (
          <FontAwesomeIcon icon={iconName} className={`${iconClasses ?? ''} mr-2 text-2xl`} />
        )}
        {pictureUrl && (
          <Avatar style={{ float: 'left', marginRight: 10 }} imageUrl={pictureUrl} size={38} />
        )}
        {title && (
          <span className='mt-1 font-bold text-base'>{title}</span>
        )}
      </div>
      <div className='block text-sm mb-3'>
        <div>
          { description }
          {moreDescription && !isExpanded && (
            <button type='button' onClick={toggleIsExpanded} className='text-sapphire'>&nbsp;+ Expand</button>
          )}
        </div>
        {moreDescription && isExpanded && (
          <div className='mt-2 text-xs'>
            { moreDescription }
            <button type='button' onClick={toggleIsExpanded} className='text-sapphire'>&nbsp;- Collapse</button>
          </div>
        )}
      </div>
      {hasButton && (
        <div className='mb-4'>{ buttonComponent }</div>
      )}
    </div>
  );
};

export { WidgetCard };
